import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import mtStyles from '../../styles/mtStyles';
import DataTable from '../datatable';
import AddIcon from '@material-ui/icons/Add';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { useSelector } from 'react-redux';
import { Button, Link, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { replacePlaceholderFields } from '../placeholders';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, IconButton } from '@material-ui/core';
import { useGetAllSMSTemplatesQuery, useSetOngoingSMSTemplateMutation } from '../../apis/backend';


const SMSTemplateList = () => {
  const chainId = useSelector(state => state.doris.selectedChain);
  const siteId = useSelector(state => state.doris.selectedSite);

  const skipGetAllSMSTemplates = !(chainId && siteId);
  const { data: templates, isLoading, error } = useGetAllSMSTemplatesQuery({ chainId, siteId }, { skip: skipGetAllSMSTemplates });
  const [setOngoingSMSTemplate] = useSetOngoingSMSTemplateMutation();

  const [openDialog, setOpenDialog] = useState(false);
  const [ongoingCandidate, setOngoingCandidate] = useState();

  const snackbar = useSnackbar();
  const history = useHistory();
  const { t } = useTranslation();

  const classes = mtStyles();

  const editSMSTemplate = (id) => {
    history.push(`/templates/sms/${id}`);
  };

  const columns = [
    {
      Header: t('ongoing'),
      accessor: 'ongoing',
    },
    {
      Header : 'id',
      accessor : 'id'
    },
    {
      Header : t('title'),
      accessor : 'title'
    },
    {
      Header : t('text-content'),
      accessor : 'message_content'
    },
    {
      Header : t('text-created'),
      accessor : 'created'
    }
  ];

  const mapTableBody = (templates) => {
    return (
      <>
        {templates.map((template, index) => (
          <TableRow
            style={index % 2 ? { background: '#FBFBFB' } : { background: 'white' }}
            key={index}>
            <TableCell style={{ width: '1%', textAlign: 'center' }}>
              <Link
                onClick={() => {
                  setOngoingCandidate(template);
                  setOpenDialog(true);
                }}>
                <IconButton>
                  { template.ongoing
                    ? <StarIcon color="primary" />
                    : <StarBorderIcon className={classes.unstarred} />
                  }
                </IconButton>
              </Link>
            </TableCell>
            <TableCell>
              <Typography noWrap>{template.id}</Typography>
            </TableCell>
            <TableCell>
              <Link
                className={classes.link}
                onClick={() => editSMSTemplate(template.id)}
              >
                <Typography noWrap>{template.title}</Typography>
              </Link>
            </TableCell>
            <TableCell style={{ maxWidth: 400 }}>
              <Typography noWrap>{replacePlaceholderFields(template.message_content, {}, 'sms')}</Typography>
            </TableCell>
            <TableCell style={{ maxWidth: 400 }}>
              <Typography noWrap>{new Date(template.created).toLocaleString('se-FI')}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  if (error) console.error(JSON.stringify(error.data));

  return (
    <>
      <div className={classes.pageActions}>
        <Button
          style={{ display: 'none'}}
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => history.push({ pathname: '/templates/sms/add' })}>
          {t('add-sms-template')}
        </Button>
      </div>
      <DataTable
        isLoading={isLoading}
        columns={columns}
        data={templates || []}
        mapTableBody={mapTableBody} />

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}>
        <DialogTitle
          id="alert-dialog-title">
          {t('template-as-default-title')}
        </DialogTitle>

        <DialogContent>
          <DialogContentText
            id="alert-dialog-description">
            { ongoingCandidate && ongoingCandidate.ongoing
              ? t('template-as-default-remove', { ongoingCandidate })
              : t('template-as-default-message', { ongoingCandidate })
            }
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            color="default">
            {t('cancel')}
          </Button>

          <Button
            onClick={async () => {
              setOpenDialog(false);
              try {
                const result = await setOngoingSMSTemplate({ id: ongoingCandidate.id, chainId, siteId }).unwrap();
                if (result) {
                  snackbar.showMessage(t('template-as-default', {ongoingTemplate: ongoingCandidate}));
                } else {
                  snackbar.showMessage(t('template-as-default-remove-success', {ongoingTemplate: ongoingCandidate}));
                }
              } catch (error) {
                snackbar.showMessage(t('template-as-default-error', {ongoingTemplate: ongoingCandidate}));
              }
            }}
            color="primary">
            {t('save')}
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};


export default SMSTemplateList;
